import React from 'react';

import {
  LeftSidebarElementType,
  LeftSidebarMenuButton,
  LeftSidebarPanelType,
} from 'app/components/general/DetailPage/LeftSidebar/structure/types';
import {DetailPageGenericTeamsSidebar} from 'app/components/general/DetailPageGenericTeamsSidebar';
import {SidebarItem} from 'app/general/structures/SidebarItem';
import {getObjectTeamsURL} from 'app/urls';
import {getContentType} from 'app/utils/content-type';

import type {DetailPageItemType} from 'app/components/general/DetailPage/types';

function TeamsPanelContent<ItemType extends DetailPageItemType>({
  object,
  legacyRefetch,
}: LeftSidebarPanelType<ItemType>) {
  return (
    <DetailPageGenericTeamsSidebar
      object={object}
      fetchObject={() => {
        legacyRefetch();
        return Promise.resolve();
      }}
      attachedItems={object.team_names}
    />
  );
}

function TeamsMenuButton<ItemType extends DetailPageItemType>({
  object,
  forceTooltipShow,
  hideTooltip,
  location,
  active,
}: LeftSidebarMenuButton<ItemType>) {
  const contentType = getContentType('team');
  return (
    <SidebarItem
      title={contentType.pluralName}
      active={active}
      icon={contentType.icon}
      link={getObjectTeamsURL(object, location.search)}
      forceTooltipShow={forceTooltipShow}
      onClick={hideTooltip}
    />
  );
}

export const TeamsSidebar: LeftSidebarElementType<DetailPageItemType> = {
  Panel: TeamsPanelContent,
  MenuButton: TeamsMenuButton,
  type: 'left',
  sidebarName: 'showTeams',
};
